import userApi from '../apis/userApi';
import aesReduxConstants from '../constants';
import userSelectors from '../selectors/userSelectors';
import clientActions from './clientActions';
import contextSelectors from '../selectors/contextSelectors';

const userActions = function() {
  const factory = {};
  const constants = aesReduxConstants;

  factory.setSession = function(sessionData) {
    return {
      type: constants.SET_USER_SESSION,
      sessionData,
    };
  };

  factory.setLocationSetId = function(locationSetId) {
    return {
      type: constants.USER.SET_LOCATION_SET_ID,
      locationSetId,
    };
  };

  /*
   * setContext
   * sets the user and client context for all of the contextual data.
   * userId: user to impersonate
   * clientId: client to impersonate
   * userClientId: users sessions client id
   */
  factory.setContext = function(userId, clientId, userClientId) {
    return function(dispatch, getState) {
      const state = getState();

      const oldContextUserClientId = contextSelectors.selectUserClientId(state);

      let newContext = {};

      // check if this actions just needs to set userId and clientId
      // typically you would only call this function on initial load sense
      // userClientId is the current sessions clientId
      if (userClientId == undefined) {
        newContext = {
          userId,
          clientId,

          // continue to use the current sessions clientId
          // TODO: this seems like a hack and should change with the state shape
          userClientId: oldContextUserClientId,
        };
      } else {
        newContext = {
          userId,
          clientId,
          userClientId,
        };
      }

      return dispatch({
        type: constants.SET_USER_CONTEXT,
        context: newContext,
      });
    };
  };

  factory.getClientDetails = function(clientId) {
    return function(dispatch) {
      userApi.getClientDetails(clientId)
        .then((response) => {
          const details = response.data;
          dispatch({ type: constants.GET_CLIENT_DETAILS, client: details });
        }, (error) => {
        });
    };
  };

  return factory;
};

export default userActions();
